export default {
  'mal-entendant-partiel': '\u{f101}',
  'mal-entendant': '\u{f102}',
  psychique: '\u{f103}',
  moteur: '\u{f104}',
  picto: '\u{f105}',
  pmr: '\u{f106}',
  'femme-enceinte': '\u{f107}',
  senior: '\u{f108}',
  'mal-voyant-partiel': '\u{f109}',
  'mal-voyant': '\u{f10a}',
  wc: '\u{f10b}',
}
